import { ApiError, NetworkError } from './api-client';
import type { useI18n } from './i18n';

/**
 * Turning a thrown thing into a sentence for the person looking at the screen.
 *
 * The three cases are genuinely different and the distinction matters to the
 * reader: the network failed and retrying may work; the server refused and
 * said why, in words chosen for a human; or something we did not anticipate
 * happened, in which case a generic sentence is more honest than guessing.
 *
 * This lived as an identical copy in eleven files. One of them drifting — a
 * swallowed ApiError message, say — would have been invisible.
 */
export function describe(e: unknown, t: ReturnType<typeof useI18n>['t']): string {
  if (e instanceof NetworkError) return t.errors.network;
  // A refusal the app already has words for is said in the reader's language;
  // the server's own sentence is English.
  if (e instanceof ApiError && e.code === 'slot_taken') return t.appointments.slotTaken;
  if (e instanceof ApiError) return e.message;
  return t.common.error;
}
